module.exports = __webpack_public_path__ + "img/paper.378618c9.svg";